(function ($) {
    window.stripSymbols = function (str) {
        return str.replace(/[^a-zA-z0-9\-\.(){}\[\]\/]/gmi, " ").replace(/\s+/g, " ");
    };
    window.utmTracking = {
        values: {},
        init: function () {
            console.log('App.utmTracking.init');
            window.utmTracking.initUtmTracking();
        },
        initUtmTracking: function () {
            var url = new URL(window.location.href);
            //Pass the URL parameters to the links
            var checklist = 'utm_source,utm_medium,utm_campaign,utm_content,utm_term'.split(',');
            var params = {};
            var plnCookies = {
                // Sets cookies.
                createCookie: function (name, value, days) {
                    var expires = '';
                    // If we have a days value, set it in the expiry of the cookie.
                    if (days) {
                        var date = new Date();
                        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                        expires = '; expires=' + date.toGMTString();
                    } else {
                        expires = '';
                    }

                    // Write the cookie.
                    document.cookie = name + '=' + value + expires + '; path=/';
                },
                // Retrieves cookies.
                getCookie: function (name) {
                    var nameEQ = name + '=';
                    var ca = document.cookie.split(';');
                    for (var i = 0; i < ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) == ' ') {
                            c = c.substring(1, c.length);
                        }
                        if (c.indexOf(nameEQ) == 0) {
                            return c.substring(nameEQ.length, c.length);
                        }
                    }

                    return null;
                },
                // Removes cookies.
                removeCookie: function (name) {
                    this.createCookie(name, false, -1);
                }
            };
            // Default values.
            var currentDomain = window.location.hostname;
            var plnReferrer = false;
            var utm_medium = 'Direct: store-petlink-net';
            var utm_source = currentDomain.replaceAll('.', '-');
            //Check if URL has utm parameters.
            if (url.searchParams.has('utm_medium') &&
                (url.searchParams.get('utm_medium') !== null) &&
                url.searchParams.get('utm_source') &&
                (url.searchParams.get('utm_source') !== '')) {
                utm_medium = window.stripSymbols(url.searchParams.has('utm_medium') ? url.searchParams.get('utm_medium') : utm_medium);
                utm_source = window.stripSymbols(url.searchParams.get('utm_source') ? url.searchParams.get('utm_source') : utm_source);
            } else {
                //Check if referrer is set.
                if (document.referrer) {
                    var referrer = new URL(document.referrer);
                    var referrerDomain = referrer.hostname;
                    if ((referrerDomain !== currentDomain)) {
                        plnReferrer = window.stripSymbols(referrerDomain.replaceAll('.', '-'));
                        plnCookies.createCookie('pln_referrer', referrerDomain.replaceAll('.', '-'));
                    } else {
                        // If referrer is not set, check if cookie is set.
                        plnReferrer = plnCookies.getCookie('pln_referrer');
                        plnReferrer = plnReferrer ? window.stripSymbols(plnReferrer.replaceAll('.', '-')) : false;
                    }
                } else {
                    // If referrer is not set, check if cookie is set.
                    plnReferrer = plnCookies.getCookie('pln_referrer');
                    plnReferrer = plnReferrer ? window.stripSymbols(plnReferrer.replaceAll('.', '-')) : false;
                }
                // Prepare referrer values
                if (plnReferrer) {
                    // Check if referrer is a search engine.
                    if ((plnReferrer.indexOf('google') > -1) ||
                        (plnReferrer.indexOf('bing') > -1) ||
                        (plnReferrer.indexOf('yahoo') > -1) ||
                        (plnReferrer.indexOf('baidu') > -1) ||
                        (plnReferrer.indexOf('yandex') > -1) ||
                        (plnReferrer.indexOf('duckduckgo') > -1) ||
                        (plnReferrer.indexOf('ask') > -1) ||
                        (plnReferrer.indexOf('aol') > -1) ||
                        (plnReferrer.indexOf('msn') > -1)) {
                        utm_medium = 'Organic/Search';
                    } else {
                        utm_medium = 'Referral';
                    }
                    utm_source = plnReferrer;
                }
            }
            params.utm_source = utm_source;
            params.utm_medium = utm_medium;
            checklist.forEach(function (item, index) {
                if (url.searchParams.has(item) && (url.searchParams.get(item) !== null)) {
                    params[item] = window.stripSymbols(url.searchParams.get(item));
                } else {
                    if (plnCookies.getCookie(item)) {
                        params[item] = plnCookies.getCookie(item);
                    }
                }
            });
            var paramsTotransfer = {};
            for (var key in params) {
                plnCookies.createCookie(key, params[key]);
                window.utmTracking.values[key] = params[key];
                paramsTotransfer[key] = params[key];
            }
            //Pass url params to Store
            var originalUrl = new URL(window.location.href);
            originalUrl.searchParams.forEach(function (value, key) {
                if (key.startsWith('utm_')) {
                    paramsTotransfer[key] = window.stripSymbols(value);
                }
            });
            window.utmTracking.values = paramsTotransfer;
        }
    };
    window.utmTracking.init();
})(jQuery);
(function ($) {
    window.PetLinkBrazeManager = {
        petlinkUrl: "https://petlink.net/",
        BRAZE_API_KEY: '2f000da2-de1f-4685-b130-cd4187ba842f',
        BRAZE_SDK_ENDPOINT: 'https://rest.fra-02.braze.eu',
        maybeInit: function () {
            if ((typeof window.braze === 'undefined' || !window.braze) && $('body#petlinkgps-for-dogs').length &&
                window.PetLinkBrazeManager.BRAZE_API_KEY &&
                window.PetLinkBrazeManager.BRAZE_SDK_ENDPOINT) {
                console.log('Braze not initialized');
                window.PetLinkBrazeManager.init();
            }
        },
        maybeLoggedInUser: function () {
            $.ajax(window.PetLinkBrazeManager.petlinkUrl + 'wp-admin/admin-ajax.php?action=get_owner_details',
                {
                    cache: false,
                    dataType: "jsonp",
                    success: function (response) {
                        if (window.PetLinkBrazeManager.isEmpty(response)) {
                            return;
                        }
                        window.PetLinkBrazeManager.maybeInit();
                        window.PetLinkBrazeManager.setUser(response);
                        window.PetLinkBrazeManager.maybeLogEvents();
                    }
                });
        },
        setUser: function (user) {
            // optionally set the current user's external ID before starting a new session
            // you can also call `changeUser` later in the session after the user logs in
            braze.changeUser('pl_owner' + '_' + user.id);
            // `openSession` should be called last - after `changeUser` and `automaticallyShowInAppMessages`
            braze.openSession();
        },
        maybeLogEvents: function () {
            if (typeof braze === 'undefined' || !braze || typeof braze.logCustomEvent !== 'function') {
                console.log('Braze not initialized, cannot log events');
                return;
            }
            if ($('body#petlinkgps-for-dogs').length) {
                var params = window.utmTracking.values || {};
                params.full_url = window.location.href;
                params.url = window.location.protocol + "//" + window.location.host + "/" + window.location.pathname;
                params.referrer = document.referrer;
                braze.logCustomEvent('page_view', params);
            }
        },
        init: function () {
            window.PetLinkBrazeManager.addScript();
            // initialize the SDK
            braze.initialize(window.PetLinkBrazeManager.BRAZE_API_KEY, {
                baseUrl: window.PetLinkBrazeManager.BRAZE_SDK_ENDPOINT,
                enableLogging: true, // set to `true` for debugging
                allowUserSuppliedJavascript: false, // set to `true` to support custom HTML messages
            });
            // optionally show all in-app messages without custom handling
            braze.automaticallyShowInAppMessages();
            // if you use Content Cards
            braze.subscribeToContentCardsUpdates(function (cards) {
                // cards have been updated
            });
        },
        addScript: function () {
            +function (a, p, P, b, y) {
                a.braze = {};
                a.brazeQueue = [];
                for (var s = "BrazeSdkMetadata DeviceProperties Card Card.prototype.dismissCard Card.prototype.removeAllSubscriptions Card.prototype.removeSubscription Card.prototype.subscribeToClickedEvent Card.prototype.subscribeToDismissedEvent Card.fromContentCardsJson ImageOnly CaptionedImage ClassicCard ControlCard ContentCards ContentCards.prototype.getUnviewedCardCount ControlMessage InAppMessage InAppMessage.SlideFrom InAppMessage.ClickAction InAppMessage.DismissType InAppMessage.OpenTarget InAppMessage.ImageStyle InAppMessage.Orientation InAppMessage.TextAlignment InAppMessage.CropType InAppMessage.prototype.closeMessage InAppMessage.prototype.removeAllSubscriptions InAppMessage.prototype.removeSubscription InAppMessage.prototype.subscribeToClickedEvent InAppMessage.prototype.subscribeToDismissedEvent InAppMessage.fromJson FullScreenMessage ModalMessage HtmlMessage SlideUpMessage User User.Genders User.NotificationSubscriptionTypes User.prototype.addAlias User.prototype.addToCustomAttributeArray User.prototype.addToSubscriptionGroup User.prototype.getUserId User.prototype.getUserId User.prototype.incrementCustomUserAttribute User.prototype.removeFromCustomAttributeArray User.prototype.removeFromSubscriptionGroup User.prototype.setCountry User.prototype.setCustomLocationAttribute User.prototype.setCustomUserAttribute User.prototype.setDateOfBirth User.prototype.setEmail User.prototype.setEmailNotificationSubscriptionType User.prototype.setFirstName User.prototype.setGender User.prototype.setHomeCity User.prototype.setLanguage User.prototype.setLastKnownLocation User.prototype.setLastName User.prototype.setPhoneNumber User.prototype.setPushNotificationSubscriptionType User.prototype.setLineId InAppMessageButton InAppMessageButton.prototype.removeAllSubscriptions InAppMessageButton.prototype.removeSubscription InAppMessageButton.prototype.subscribeToClickedEvent FeatureFlag FeatureFlag.prototype.getStringProperty FeatureFlag.prototype.getNumberProperty FeatureFlag.prototype.getBooleanProperty FeatureFlag.prototype.getImageProperty FeatureFlag.prototype.getJsonProperty FeatureFlag.prototype.getTimestampProperty Banner Banner.prototype.getStringProperty Banner.prototype.getNumberProperty Banner.prototype.getBooleanProperty Banner.prototype.getImageProperty Banner.prototype.getJsonProperty Banner.prototype.getTimestampProperty automaticallyShowInAppMessages hideContentCards showContentCards showInAppMessage deferInAppMessage toggleContentCards changeUser destroy getDeviceId getDeviceId initialize isPushBlocked isPushPermissionGranted isPushSupported logCardDismissal logContentCardImpressions logContentCardClick logCustomEvent logInAppMessageButtonClick logInAppMessageClick logInAppMessageHtmlClick logInAppMessageImpression logPurchase openSession requestPushPermission removeAllSubscriptions removeSubscription requestContentCardsRefresh refreshFeatureFlags requestImmediateDataFlush enableSDK isDisabled setLogger setSdkAuthenticationSignature addSdkMetadata disableSDK subscribeToContentCardsUpdates subscribeToInAppMessage subscribeToSdkAuthenticationFailures toggleLogging unregisterPush wipeData handleBrazeAction subscribeToFeatureFlagsUpdates getAllFeatureFlags logFeatureFlagImpression requestBannersRefresh insertBanner getAllBanners subscribeToBannersUpdates isInitialized".split(" "), i = 0; i < s.length; i++) {
                    for (var m = s[i], k = a.braze, l = m.split("."), j = 0; j < l.length - 1; j++) k = k[l[j]];
                    k[l[j]] = (new Function("return function " + m.replace(/\./g, "_") + "(){window.brazeQueue.push(arguments); return true}"))()
                }
                window.braze.getDeferredInAppMessage = function () {
                    return new window.braze.InAppMessage
                };
                window.braze.getCachedContentCards = function () {
                    return new window.braze.ContentCards
                };
                window.braze.getUser = function () {
                    return new window.braze.User
                };
                window.braze.getFeatureFlag = function () {
                    return new window.braze.FeatureFlag
                };
                window.braze.getBanner = function () {
                    return new window.braze.Banner
                };
                window.braze.newBannerFromJson = function () {
                    return new window.braze.Banner
                };
                (y = p.createElement(P)).type = 'text/javascript';
                y.src = 'https://js.appboycdn.com/web-sdk/6.1/braze.min.js';
                y.async = 1;
                (b = p.getElementsByTagName(P)[0]).parentNode.insertBefore(y, b)
            }(window, document, 'script');
        },
        isEmpty: function (obj) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    return false;
                }
            }
            return (JSON.stringify(obj) === JSON.stringify({})) || (JSON.stringify(obj) === JSON.stringify([]));
        }
    };
    window.PetLinkBrazeManager.maybeLoggedInUser();
})(jQuery);